import { ReactNode, useState } from "react";
import { useVersionCheck } from "../hooks/useVersionCheck";
import { VersionUpdateDialog } from "./VersionUpdateDialog";

type VersionCheckProviderProps = {
	children: ReactNode;
};

export const VersionCheckProvider = ({ children }: VersionCheckProviderProps) => {
	const { hasNewVersion, currentVersion, latestVersion } = useVersionCheck();
	const [dialogDismissed, setDialogDismissed] = useState(false);

	const handleClose = () => {
		setDialogDismissed(true);
	};

	const handleUpdate = () => {
		// Hard reload um sicherzustellen, dass der Cache geleert wird
		window.location.reload();
	};

	return (
		<>
			{children}
			<VersionUpdateDialog
				open={hasNewVersion && !dialogDismissed}
				currentVersion={currentVersion}
				latestVersion={latestVersion}
				onClose={handleClose}
				onUpdate={handleUpdate}
			/>
		</>
	);
};
